define('lib/Podio.UI.SpaceInvitations.New',['require','translate','underscore','jquery','lib/jquery/jquery.balloon','lib/Podio.Router','lib/Podio.UI.Modal','lib/Podio.Config','lib/Podio.Routes','lib/Podio.Store','lib/Podio.Transport','lib/Podio.UI','lib/Podio.Utils','lib/Podio.UI.CreateSpaceModal','lib/Podio.Event.UI','lib/Podio.Utils.Text','lib/Podio.Event','lib/Podio.Bootstrap','lib/Podio.Transport.SpaceInvitations.Profiles','controllers/avatar_uploader/Podio.Controllers.AvatarUploader','lib/Podio.UI.SimpleBalloon','lib/Podio.UI.PeoplePicker'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.balloon');

  var router = require('lib/Podio.Router');
  var modal = require('lib/Podio.UI.Modal');
  var podioConfig = require('lib/Podio.Config');
  var routes = require('lib/Podio.Routes');
  var podioStore = require('lib/Podio.Store');
  var transport = require('lib/Podio.Transport');
  var podioUI = require('lib/Podio.UI');
  var utils = require('lib/Podio.Utils');
  var createSpaceModal = require('lib/Podio.UI.CreateSpaceModal');
  var eventUI = require('lib/Podio.Event.UI');
  var textUtils = require('lib/Podio.Utils.Text');
  var podioEvent = require('lib/Podio.Event');
  var bootstrap = require('lib/Podio.Bootstrap');

  var transportProfiles = require('lib/Podio.Transport.SpaceInvitations.Profiles');

  var avatarsController = require('controllers/avatar_uploader/Podio.Controllers.AvatarUploader');

  // simpe_invite dependencies
  var SimpleBalloon = require('lib/Podio.UI.SimpleBalloon');
  var PeoplePicker = require('lib/Podio.UI.PeoplePicker');
  var peoplePicker;
  var roleBalloon;

  var elmInputEmailPicker, elmInputEmailPickerInputToken, elmMessageComposer, elmInvitationBox, elmInvitationBoxForm;
  var targetSpaceId, passedContactIds = [], passedContactEmails = [];

  var employeeNetworkDomains, organizationName, employeeNetwork;

  var prefillPicker;
  var prefillMessage;
  var prefillRole;

  var helpers = {

    showProfileUploadModal: function(notice) {
      var ac = new avatarsController({
        context: 'invite'
      });
    },

    onEmailBeforeAdded : function(email) {


      if (!textUtils.isValidEmail(email) || (employeeNetwork && employeeNetworkDomains.length > 0 && _.all(employeeNetworkDomains, function(domain) { return email.indexOf('@' + domain) === -1; })) ) {
        var message = !textUtils.isValidEmail(email)
            ? t('Please enter a valid email address #invite')
            : t('In the Employee Network only people from {0} should have access. In workspaces, you can work together with anyone, e.g. clients or contractors. #empnetwork.message').format(organizationName);

        // a baloon is already opened and this function is called twice (once by tokenize hotkey, another time by an outsideclick)
        if (!$('.balloon').length) {
          elmInputEmailPickerInputToken.trigger('remove-balloon');
          elmInputEmailPickerInputToken.balloon({
            maxMessageWidth : 170,
            offset: '-120,0',
            allowMultiple: false,
            hint: false,
            position: 'below',
            sticky: 'sticky',
            visible: true,
            message: message,
            style : 'on-top-modal'
          });
        }

        return false;
      } else {

        helpers.toggleSimpleButton(true);

        elmInputEmailPickerInputToken.trigger('remove-balloon');

        return true;
      }
    },

    onAfterTokenRemoved : function(tokenList, token) {
      elmInputEmailPickerInputToken.trigger('remove-balloon');
      if (tokenList.length === 0) {
        helpers.toggleSimpleButton(false);
      }
    },

    onAfterTokenAdded: function(tokenList, id) {
      elmInputEmailPickerInputToken.trigger('remove-balloon');
      helpers.toggleSimpleButton(true);
    },

    onInputBlur: function() {
      if (!elmInputEmailPicker.parent().find('.token-input-input-token input').val().length) {
        elmInputEmailPickerInputToken.trigger('remove-balloon');
        helpers.toggleSimpleButton(true);
      }

      _.defer(function() {
        if (!elmInputEmailPickerInputToken.val().length && !elmInputEmailPicker.parent().find('.token-input-token').length) {
          helpers.toggleSimpleButton(false);
        }
      });
    },

    onPeoplePickerDone: function() {
      if (elmInputEmailPicker.parent().find('.token-input-list.no-tokens').length) {
        helpers.toggleSimpleButton(false);
      } else {
        helpers.toggleSimpleButton(true);
      }
    },

    toggleArrowIcon: function(elmLink) {
      elmLink.find('.img-ext').toggleClass('icon-arrow-down-grey icon-arrow-up-grey');
    },

    resetArrowIcon: function(elmLink) {
      elmLink.find('.img-ext').addClass('icon-arrow-down-grey').removeClass('icon-arrow-up-grey');
    },

    onModalClosed : function() {
      if (elmInputEmailPickerInputToken) {
        elmInputEmailPickerInputToken.trigger('remove-balloon');
      }
      $('.message-composer .message textarea').trigger('remove-balloon');
      router.goToHashRoute('');
      return true;
    },

    toggleSimpleButton: function(toggle) {
      $('#invitation-box-simple .main-button').toggleClass('disabled', !toggle);
    }

  };

  function init() {
    var restoreTokens;

    if (!_.isUndefined(prefillPicker) && prefillPicker.length) {
      restoreTokens = prefillPicker;
    }

    saveSpaceData(targetSpaceId, $('.invitation-form-simple'));

    elmInvitationBox = $('#invitation-box-simple');
    elmInvitationBoxForm = elmInvitationBox.find('.invitation-form-simple');

    employeeNetworkDomains = elmInvitationBoxForm.data('domains');
    employeeNetwork = elmInvitationBoxForm.data('space-type') === 'emp_network';

    organizationName = elmInvitationBoxForm.data('organization-name');

    if (passedContactIds.length || passedContactEmails.length) {
      helpers.toggleSimpleButton(true);
    }

    var isModal = elmInvitationBox.find('#is_modal').val() === 'true';

    var dfd = $.Deferred();
    var prePopulate = passedContactEmails.length ? _.map(passedContactEmails, function(item) { return { ref_type: 'mail', id: item, name: item }; }) : (restoreTokens || []);
    if (passedContactIds.length) {

      transportProfiles.getProfilesByIds(passedContactIds, function(data) {
        _.each(data.profiles, function(profile) {
          prePopulate.push($.extend({ref_type: 'profile'}, profile));
        });
        dfd.resolve();
      });

    } else {
      dfd.resolve();
    }

    dfd.done(function() {
      var placeholderText;
      if (isModal) {
        placeholderText = t('Pick connections or type email addresses #contact_app_type');
      } else {
        placeholderText = t('Type an email address separated by commas #invite');
      }

      peoplePicker = new PeoplePicker(elmInvitationBox.find('.invitation-people-picker'), 'invite', {
        prePopulate: prePopulate,
        podioPickerOptions: {
          showFreeTokenAvatar: false,
          placeholderText: placeholderText,
          onFreeTokenValidation: helpers.onEmailBeforeAdded,
          onAfterTokenAdded: helpers.onAfterTokenAdded,
          onAfterTokenRemoved: helpers.onAfterTokenRemoved,
          onInputBlur: helpers.onInputBlur
        }
      });

      elmInputEmailPicker = peoplePicker.elmInput;
      elmInputEmailPickerInputToken = peoplePicker.elmInput.parent().find('.token-input-list .token-input-input-token');

      elmInputEmailPicker.bind('peoplePicker:peopleFinderFinished', helpers.onPeoplePickerDone);

      if (elmInvitationBox.find('.roles-selector-simple .role').length) {
        roleBalloon = new SimpleBalloon({
          content: elmInvitationBox.find('.roles-options').html(),
          contentClass: 'roles-selector-balloon',
          arrowPosition: 'left',
          elmAttachmentTarget: elmInvitationBox.find('.roles-selector-simple .role')
        });
        roleBalloon.render();

        if (prefillRole) {
          $('.roles-selector-balloon .option[data-role=' + prefillRole + ']').click();
        }

      }


      if (prefillMessage) {
        $('#space_invitation_message').val(prefillMessage);
      }

    });
  }

  function pickerTokensToStateObject(tokens) {
    return _.map(tokens, function(token) {
      switch (token.ref_type) {
      case 'profile':
        return {
          id: parseInt(token.id.split('|')[1], 10),
          name: token.name,
          ref_type: token.ref_type,
          avatar: token.avatar,
          mail: token.mail
        };
      case 'mail':
        return {
          id: token.id.split('|')[1],
          name: token.name,
          ref_type: token.ref_type
        };
      case 'external':
        var idParts = token.id.split('|');
        return {
          id: idParts[2],
          name: token.name,
          ref_type: token.ref_type,
          linked_account_id: parseInt(idParts[1], 10),
          external_contact_id: idParts[2]
        };
      }
    });
  }

  function onRoleNameClicked(elmTarget, e) {
    roleBalloon.renderGravity();
    roleBalloon.show();
    // Must unbind and defer the outside click bind as it otherwise closes immediately
    roleBalloon.elm.unbind('outsideclick.roleBalloon');
    _.defer(function() {
      roleBalloon.elm.bind('outsideclick.roleBalloon', onRoleBalloonOutsideClicked);
    });
  }

  function onRoleSelectionClicked(elmTarget, e) {
    $('#invitation-box-simple #space_invitation_role').val(elmTarget.data('role'));
    $('#invitation-box-simple .roles-selector-simple .selected_role').text(elmTarget.find('.name').text());
    roleBalloon.elm.find('li.option').removeClass('selected');
    elmTarget.addClass('selected');
    roleBalloon.elm.unbind('outsideclick.roleBalloon');
    roleBalloon.hide();
  }

  function onDisabledRoleSelectionClicked(elmTarget, e) {
    roleBalloon.elm.find('.icon-16').toggleClass('icon-arrow-down-grey').toggleClass('icon-arrow-up-grey');
    roleBalloon.elm.find('.premium-explanation').toggle();
  }

  function onRoleBalloonOutsideClicked(e) {
    roleBalloon.elm.unbind('outsideclick.roleBalloon');
    roleBalloon.hide();
  }

  function onModalRouteInvoked(routeData) {
    // If a feature tour is about to be shown, waiting showing this until after the tour has been closed
    if (bootstrap.hasBootstrapData('FeatureTourSettings')) {
      var featureTourSettings = bootstrap.getBootstrapData('FeatureTourSettings');
      if (featureTourSettings && featureTourSettings.pop) {
        podioEvent.bind(podioEvent.Types.featureTourClosed, handleModalRouteInvoked.curry(routeData));
      } else {
        handleModalRouteInvoked(routeData);
      }
    } else {
      handleModalRouteInvoked(routeData);
    }

    function handleModalRouteInvoked(routeData) {

      var spaceId = routeData.params[0];
      var requestData = {};

      if (routeData.params[1] && routeData.params[2]) {
        requestData = {
          context_ref_type: routeData.params[1],
          context_ref_id: routeData.params[2]
        };
      }
      requestData.item_type = routeData.queries['type'] && routeData.queries['type'] === 'external' ? 'external' : 'employee';

      passedContactIds = routeData.queries['contactIds'] ? routeData.queries['contactIds'].toString().split(',') : [];
      passedContactEmails = routeData.queries['contactEmails'] ? routeData.queries['contactEmails'].split(',') : [];

      modal.showLoading(t('Add #addtospace'));

      if (spaceId) {
        showInviteModal(spaceId, requestData);
      } else {
        // TODO: This tight coupling with the old invite code should be cleaned up when select space logic is redone
        modal.state().contact_ids = passedContactIds;
        modal.state().contact_emails = passedContactEmails;
        modal.state().type = requestData.item_type;

        if (podioConfig.spacesCount > 0) {
          selectSpace();
        } else {
          createSpace(routes.new_space_path({variant: 'invite'}));
        }
      }

    }
  }

  function unPopFeatureTourConfig() {
    // HACK: Set the featuretour pop to false when the tour is closed, so the invite modal can be opened after that
    var featureTourSettings = bootstrap.getBootstrapData('FeatureTourSettings');
    featureTourSettings.pop = false;
  }

  function onResumeInvoked() {
    var store = podioStore.create('invitations', true);
    var spaceId = store.get('space_id');
    var stateObject = store.get('stateObject');
    store.clear();

    if (_.isUndefined(spaceId)) {
      spaceId = podioConfig.space_id;
    }

    if (!_.isUndefined(stateObject)) {
      if (!_.isUndefined(stateObject.tokens)) {
        prefillPicker = stateObject.tokens;
      }

      if (!_.isUndefined(stateObject.inviteMessage)) {
        prefillMessage = stateObject.inviteMessage;
      }

      if (!_.isUndefined(stateObject.role)) {
        prefillRole = stateObject.role;
      }

    }

    router.goToHashRoute('invite/{0}'.format(spaceId));
  }

  function saveState() {
    var store = podioStore.create('invitations', true);

    var stateObject = {
      tokens: pickerTokensToStateObject(elmInputEmailPicker.data('tokens')),
      role: $('#space_invitation_role').val(),
      inviteMessage: $('#space_invitation_message').val()
    };

    store.store('stateObject', stateObject);
  }

  function clearState() {
    var store = podioStore.create('invitations', true);
    store.clear();
  }

  function showInviteModal(spaceId, data, title) {
    var requestData = data ? data : {};
    targetSpaceId = spaceId;

    transport.getJSON(routes.new_space_json_invitation_path(spaceId), { abortable: false, requestData: requestData }, function(responseData) {
      modal.show(responseData.data.html, { title: (title || responseData.data.title), hideOnOutsideClick: false, hideHandler : helpers.onModalClosed, width: 600 });
      init();
    });
  }

  function onStandaloneRouteInvoked(routeData) {
    init();
    targetSpaceId = podioConfig.space_id || elmInvitationBoxForm.data('space-id');
  }

  function onFormButtonClicked(elmTarget, e) {
    var elmForm = elmTarget.closest('form');
    var elmMessage = elmForm.find('#space_invitation_message').val();
    var elmRole = elmForm.find('#space_invitation_role').val();
    var isModal = elmForm.find('#is_modal').val() === 'true';
    var returnTo = elmForm.find('#return_to').val();
    var contactsString = elmForm.find('.invitation-people-picker').val();

    if (!contactsString.length) {
      return false;
    }

    if (elmForm.valid()) {

      podioUI.disableButtonWithLoader(elmTarget);

      // Build requestData object
      var requestData = {
        space_invitation: _.extend({
          message: elmMessage,
          role: elmRole
        }),
        item_type: router.getHashes().type,
        people_picker_contacts: contactsString,
        is_modal: isModal,
        return_to: returnTo
      };

      requestData.space_invitation = handleContext(requestData.space_invitation);

      // XHR to create space invitations
      transport.postJSON(routes.space_json_invitation_path(targetSpaceId), { abortable: false, requestData: requestData }, function(responseData) {
        if (responseData.status === 'ok') {
          clearState();
          modal.hide();

          if (_.isFunction(modal.state().invitationSuccessCallback)) {
            // Callback used in mentions
            modal.state().invitationSuccessCallback.call(this);
          } else if (podioConfig.user.avatar === null) {
            helpers.showProfileUploadModal(responseData.data.notice);
          } else {
            router.reloadCurrentPage();
          }

        } else {
          podioUI.restoreButtonWithLoader(elmTarget);
          if (utils.isPresent(responseData.error_code)) {
            $('#limit_reached_feedback').html(responseData.data.html).removeClass('hidden');
            saveState();
            helpers.toggleSimpleButton(false);
          }
        }
      });
    }
  }

  function handleContext(data) {
    var contextRefType = $('#space_invitation_context_ref_type');
    var contextRefId = $('#space_invitation_context_ref_id');
    if (contextRefType.length && contextRefId.length) {
      _.extend(data, {
        context_ref_type: contextRefType.val(),
        context_ref_id: contextRefId.val()
      });
    }
    return data;
  }

  function getSpaceId() {
    return targetSpaceId;
  }

  function saveSpaceData(spaceId, elmForm) {
    var store = podioStore.create('invitations', true);
    var spaceUrl = elmForm.data('space-url');
    store.store('space_id', spaceId);
    store.store('space_url', spaceUrl);
  }

  function onUpgradeButtonClick(elmTarget) {
    if (!elmTarget.hasClass('action-dropdown')) {
      clearState();
    }
  }

  function selectSpace() {
    var path = routes.select_space_space_invitations_path();
    modal.showLoading(t('Add #addtospace'));
    transport.getJSON(path, {}, function(responseData) {
      modal.show(responseData.data.html, {
        title: responseData.data.title_html,
        footerHtml: responseData.data.footer_html,
        breadcrumb: responseData.data.breadcrumb_html,
        hideHandler: helpers.onModalClosed,
        hideOnOutsideClick: false
      });
    });
  }

  function createSpace(newUrl) {
    createSpaceModal.show({
      newUrl: newUrl,
      title: t('Add to a new space. #addtospace'),
      callback: function(space) {
        modal.state().space_id = space.space_id;
        router.goToHashRoute('invite/{0}'.format(space.space_id));
      }
    });
  }

  function onSpaceSelectedClicked(elmTarget, e) {
    var route_options = {};
    modal.state().space_id = $('#dropdown_space_id').val();
    if (modal.state().contact_ids) {
      route_options['contactIds'] = modal.state().contact_ids;
    }
    if (modal.state().contact_emails) {
      route_options['contactEmails'] = modal.state().contact_emails;
    }
    if (modal.state().type) {
      route_options['type'] = modal.state().type;
    }
    router.goToHashRoute('invite/{0}'.format(modal.state().space_id), route_options);
  }

  function onCreateSpaceClicked(elmTarget, e) {
    createSpace(elmTarget.attr('href'));
  }

  router.addHashRoute('invite/resume', onResumeInvoked);
  router.addHashRoute('invite/:space_id::?contactIds:/', onModalRouteInvoked, {
    rules : {
      space_id : function(value) {
        return _.isUndefined(value) || !isNaN(value);
      }
    }
  });
  router.addHashRoute('invite/:space_id:/:context_ref_type:/:context_ref_id:/', onModalRouteInvoked, {
    rules : {
      space_id : function(value) {
        return _.isUndefined(value) || !isNaN(value);
      },
      context_ref_id : function(value) {
        return _.isUndefined(value) || !isNaN(value);
      }
    }
  });
  router.addRoute('{org_slug}/{space_slug}/invite', onStandaloneRouteInvoked);

  eventUI.bind('click', '.nav-box .upgrade-section .upgrade-button', onUpgradeButtonClick, true);
  eventUI.bind('click', '.nav-box .upgrade-section .action-dropdown-wrapper .header-upgrade-link', clearState, true);
  eventUI.bind('click', '.premium-banner .banner-upgrade-button', clearState, true);
  eventUI.bind('click', '#invite_space_selected_button', onSpaceSelectedClicked);
  eventUI.bind('click', 'a.new-space', onCreateSpaceClicked);

  // Simple invite
  eventUI.bind('click', '.roles-selector-balloon .option:not(.disabled)', onRoleSelectionClicked);
  eventUI.bind('click', '.roles-selector-balloon .option.disabled', onDisabledRoleSelectionClicked);
  eventUI.bind('click', '#invitation-box-simple .roles-selector-simple .role', onRoleNameClicked);
  eventUI.bind('click', '#invitation-box-simple .main-button:not(.disabled)', onFormButtonClicked);

  // Keep track of whether tour is running
  podioEvent.bind(podioEvent.Types.featureTourClosed, unPopFeatureTourConfig);

  return {
    init: init,
    showInviteModal: showInviteModal,
    getSpaceId: getSpaceId
  };

});

